module.exports = __webpack_public_path__ + "66c84b6a04e55d96ed99e93c0dab57c0.png";